import React from 'react'
import PropTypes from 'prop-types'
import mask from 'media/mask.svg'

export default function Mask({ children, className }) {
  const maskValue = `url(${mask}) bottom center / 100% auto`

  return (
    <div className={className}>
      <div
        style={{
          WebkitMask: maskValue,
          mask: maskValue,
        }}
      >
        {children}
      </div>
    </div>
  )
}

Mask.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
